import React, { Component } from 'react';
import { connect } from 'react-redux';
import axios from 'axios';
import isEmpty from 'lodash/isEmpty';
import omit from 'lodash/omit';
import NumberFormat from 'react-number-format';
import InputMoment from 'input-moment';
import moment from 'moment-timezone';
import update from 'immutability-helper';

// Components
import Loader from '../../utils/Loader';
import SaleCodeItem from './SaleCodeItem';
import BuyXGetY from './BuyXGetY';

// State
import { addRoute } from '../../../store/actions/route';
import { setpageTitle, getFreeShipping } from '../../../store/actions/siteInfo';
import { userTokenUpdate, userLogout } from '../../../store/actions/user';
import { REACT_APP_API_URL, REACT_APP_SITE_KEY } from '../../../shared/vars';

// CSS
import '../../../css/toggles.css';
import '../../../css/discounts.css';
import '../../../css/input-moment/input-moment.css';
import BuyXGetYItem from './BuyXGetYItem';

class AdminDiscounts extends Component {
	constructor(props) {
		super(props);

		this.state = {
			isLoading: true,
			codes: [],
			newCode: {
				code: '',
				sale_type: false,
				value: '',
				min_sale_amount: '',
				expires: null,
			},
			bogoItems: [],
			bogoItem: {
				id: null,
				code: '',
				message: '',
				req_type: 'value',
				req_value: '',
				discount_qty: 1,
				discount_type: 'percentage',
				discount_value: '',
				buy_categories: [],
				buy_products: [],
				get_categories: [],
				get_products: [],
				max_uses: '',
				start_date: '',
				end_date: '',
				auto_add: false,
				no_buy_items: false,
				give_free_shipping: false,
				top_tier_id: 0,
			},
			bogoEditId: null,
			shipping: {},
			error: '',
			updateLoading: false,
			updateSuccess: '',
			updateErrors: {},
			discountSuccess: '',
			itemIndex: 'new',
			couponGeneralSelected: true,
		};
		this.baseBogoState = this.state.bogoItem;
		this.handleDiscountClick = this.handleDiscountClick.bind(this);
		this.resetDiscountForm = this.resetDiscountForm.bind(this);
		this.props.addRoute(this.props.match);
		this.props.setpageTitle('Discounts');
	}

	// ===================================================================================
	//  LOAD DATA
	// ===================================================================================
	componentDidMount() {
		this.loadDataGeneral();
		this.loadDataDiscounts();
		this.props.getFreeShipping();
	}

	UNSAFE_componentWillReceiveProps(nextProps) {
		let changed = false;
		Object.keys(nextProps.shipping).forEach((key) => {
			if (nextProps.shipping[key] !== this.props.shipping[key]) {
				changed = true;
				return true;
			}
		});

		// Ensure dates are valid
		let start = moment(moment.utc(nextProps.shipping.start).local().format());
		let end = moment(moment.utc(nextProps.shipping.end).local().format());

		if (!start.isValid()) {
			start = moment();
		}
		if (!end.isValid()) {
			end = moment();
		}

		nextProps.shipping.start = start;
		nextProps.shipping.end = end;

		// If any values have changed, set the state
		if (changed) {
			nextProps.shipping.is_min_qty = !!nextProps.shipping.minimum_items;
			this.setState({ shipping: nextProps.shipping });
		}
	}

	loadDataGeneral() {
		const { user } = this.props;

		this.setState({ isLoading: true }, () => {
			const token = user.token;
			const AUTH_HEADER = {
				Authorization: REACT_APP_SITE_KEY + ':Bearer ' + token,
			};
			return axios
				.get(REACT_APP_API_URL + 'sale-code/all', { headers: AUTH_HEADER })
				.then((response) => {
					if (
						response.status === 403 ||
						(response.data.status && response.data.status === 403)
					) {
						this.props.userLogout('admin');
					} else if (
						response.status !== 200 ||
						(response.data.status && response.data.status !== 200)
					) {
						this.setState({ isLoading: false, error: response.data.message });
					} else {
						this.setState({
							isLoading: false,
							codes: isEmpty(response.data.codes)
								? []
								: Object.keys(response.data.codes).map((key) => {
										const item = response.data.codes[key];
										item.sale_type = item.sale_type === 'dollar' ? true : false;
										return item;
								  }),
						});
					}
				})
				.catch((err) => {
					if (err.response) {
						this.setState({
							isLoading: false,
							error: err.response.data.errors
								? err.response.data.errors
								: err.response.data.message,
						});
					} else {
						this.setState({ isLoading: false, error: err.message });
					}
				});
		});
	}

	loadDataDiscounts() {
		const { user } = this.props;
		this.setState({ isLoading: true }, () => {
			const token = user.token;
			const AUTH_HEADER = {
				Authorization: REACT_APP_SITE_KEY + ':Bearer ' + token,
			};
			return axios
				.get(REACT_APP_API_URL + 'discount-multiple/all', {
					headers: AUTH_HEADER,
				})
				.then((response) => {
					if (
						response.status === 403 ||
						(response.data.status && response.data.status === 403)
					) {
						this.props.userLogout('admin');
					} else if (
						response.status !== 200 ||
						(response.data.status && response.data.status !== 200)
					) {
						this.setState({ isLoading: false, error: response.data.message });
					} else {
						this.setState({
							isLoading: false,
							bogoItems: response.data.discount_codes,
						});
					}
				})
				.catch((err) => {
					if (err.response) {
						this.setState({
							isLoading: false,
							error: err.response.data.errors
								? err.response.data.errors
								: err.response.data.message,
						});
					} else {
						this.setState({ isLoading: false, error: err.message });
					}
				});
		});
	}

	// ===================================================================================
	//  INPUT CHANGES
	// ===================================================================================
	handleKeyPress(event) {
		if (event.key === 'Enter') {
			event.preventDefault();
			this.handleFreeShippingSubmit();
		}
	}

	handleNumberChange(id, valueObject) {
		this.setState({
			shipping: {
				...this.state.shipping,
				[id]: valueObject.value,
			},
		});
	}

	handleCheckboxClick(event) {
		const { id } = event.target;
		this.setState({
			shipping: {
				...this.state.shipping,
				[id]: !this.state.shipping[id],
			},
		});
	}

	handleKeyPressSaleCode(event) {
		if (event.key === 'Enter') {
			event.preventDefault();
		}
	}

	changeSaleCode(value, itemIndex, name) {
		if (itemIndex === 'new') {
			this.setState({
				newCode: update(this.state.newCode, {
					[name]: { $set: value },
				}),
			});
		} else {
			this.setState({
				codes: update(this.state.codes, {
					[itemIndex]: {
						showButton: { $set: true },
						[name]: { $set: value },
					},
				}),
			});
		}
	}

	changeDiscountCode(value, itemIndex, name) {
		if (itemIndex === 'new') {
			this.setState({
				bogoItem: update(this.state.bogoItem, {
					[name]: { $set: value },
				}),
			});
		} else {
			this.setState({
				bogoItems: update(this.state.bogoItems, {
					[itemIndex]: {
						showButton: { $set: true },
						[name]: { $set: value },
					},
				}),
			});
		}
	}

	handleDiscountCatProdUpdate(selections, type) {
		this.setState({
			bogoItem: update(this.state.bogoItem, {
				[type]: { $set: selections },
			}),
		});
	}

	handleDiscountCatProdDelete(i, type) {
		this.setState({
			bogoItem: update(this.state.bogoItem, {
				[type]: { $set: [] },
				// [type]: { $set: this.state.bogoItem[type].filter((_, catIndex) => catIndex !== i) }
			}),
		});
	}

	handleCheckboxClickSaleCode(itemIndex, name) {
		if (itemIndex === 'new') {
			this.setState({
				newCode: update(this.state.newCode, {
					[name]: { $set: !this.state.newCode[name] },
				}),
			});
		} else {
			this.setState({
				codes: update(this.state.codes, {
					[itemIndex]: {
						showButton: { $set: true },
						[name]: { $set: !this.state.codes[itemIndex][name] },
					},
				}),
			});
		}
	}

	handleCheckboxClickDiscountCode(itemIndex, name) {
		if (itemIndex === 'new') {
			this.setState({
				bogoItem: update(this.state.bogoItem, {
					[name]: { $set: !this.state.bogoItem[name] },
				}),
			});
		} else {
			this.setState({
				bogoItems: update(this.state.bogoItems, {
					[itemIndex]: {
						showButton: { $set: true },
						[name]: { $set: !this.state.bogoItems[itemIndex][name] },
					},
				}),
			});
		}
	}

	handleDiscountClick() {
		this.setState({
			couponGeneralSelected: !this.state.couponGeneralSelected,
		});
	}

	handleUpdateSelectBox(selection, id) {
		if (id === 'req_type') {
			this.setState({
				bogoItem: update(this.state.bogoItem, {
					no_buy_items: { $set: false },
					[id]: { $set: selection.type },
				}),
			});
		} else {
			this.setState({
				bogoItem: update(this.state.bogoItem, {
					[id]: { $set: selection.type },
				}),
			});
		}
	}

	// ===================================================================================
	//  SUBMIT
	// ===================================================================================
	handleFreeShippingSubmit() {
		const { user } = this.props;
		const { shipping } = this.state;

		this.setState(
			{
				updateLoading: true,
				updateSuccess: '',
				updateErrors: {},
			},
			() => {
				const data = {
					...omit(shipping, ['start', 'end', 'minimum_sale']),
					free_shipping_start: moment(shipping.start).utc(),
					free_shipping_end: moment(shipping.end).utc(),
					min_sale_amount: shipping.minimum_sale,
				};

				const token = user.token;
				const AUTH_HEADER = {
					Authorization: REACT_APP_SITE_KEY + ':Bearer ' + token,
				};
				return axios
					.post(REACT_APP_API_URL + 'free-shipping', data, {
						headers: AUTH_HEADER,
					})
					.then((response) => {
						// Check user token
						if (!!response.data.token) {
							this.props.userTokenUpdate('admin', response.data.token);
						} else {
							this.props.userLogout('admin');
						}

						if (
							response.status !== 200 ||
							(response.data.status && response.data.status !== 200)
						) {
							// Create error object
							let errorObj = '';
							if (!isEmpty(response.data.errors)) {
								errorObj = response.data.errors;
							} else if (!isEmpty(response.data.error)) {
								errorObj = { general: response.data.error };
							} else {
								errorObj = { general: response.data.message };
							}

							this.setState({
								updateLoading: false,
								updateErrors: errorObj,
							});
						} else {
							this.setState(
								{
									updateLoading: false,
									updateSuccess: response.data.message,
								},
								() => this.props.getFreeShipping()
							);
						}
					})
					.catch((err) => {
						if (err.response) {
							this.setState({
								updateLoading: false,
								updateErrors: {
									general: err.response.data.error
										? err.response.data.error
										: err.response.data.message,
								},
							});
						} else {
							this.setState({
								updateLoading: false,
								updateErrors: { general: err.message },
							});
						}
					});
			}
		);
	}

	// ===================================================================================
	//  SALE CODES
	// ===================================================================================
	addSaleCade() {
		const { user } = this.props;

		this.setState(
			{
				newCode: update(this.state.newCode, {
					$unset: ['errors'],
					updateLoading: { $set: true },
				}),
			},
			() => {
				let item = {
					...omit(this.state.newCode, ['expires', 'sale_type']),
					expiry: this.state.newCode.expires,
					price_type: this.state.newCode.sale_type ? 'dollar' : 'percentage',
				};

				const token = user.token;
				const AUTH_HEADER = {
					Authorization: REACT_APP_SITE_KEY + ':Bearer ' + token,
				};
				return axios
					.post(REACT_APP_API_URL + 'sale-code/', item, {
						headers: AUTH_HEADER,
					})
					.then((response) => {
						// Check user token
						if (!!response.data.token) {
							this.props.userTokenUpdate('admin', response.data.token);
						} else {
							this.props.userLogout('admin');
						}

						if (
							response.status !== 200 ||
							(response.data.status && response.data.status !== 200)
						) {
							// Create error object
							let errorObj = '';
							if (!isEmpty(response.data.errors)) {
								errorObj = response.data.errors;
							} else if (!isEmpty(response.data.error)) {
								errorObj = { general: response.data.error };
							} else {
								errorObj = { general: response.data.message };
							}

							this.setState({
								newCode: update(this.state.newCode, {
									updateLoading: { $set: false },
									errors: { $set: errorObj },
								}),
							});
						} else {
							this.setState({
								// Reset new code
								newCode: update(this.state.newCode, {
									code: { $set: '' },
									sale_type: { $set: false },
									value: { $set: '' },
									min_sale_amount: { $set: '' },
									expires: { $set: null },
									updateLoading: { $set: false },
								}),

								// Add new record to codes
								codes: update(this.state.codes, {
									$unshift: [response.data.record],
								}),
							});
						}
					})
					.catch((err) => {
						if (err.response) {
							this.setState({
								newCode: update(this.state.newCode, {
									updateLoading: { $set: false },
									errors: {
										$set: {
											general: err.response.data.error
												? err.response.data.error
												: err.response.data.message,
										},
									},
								}),
							});
						} else {
							this.setState({
								newCode: update(this.state.newCode, {
									updateLoading: { $set: false },
									errors: { $set: { general: err.message } },
								}),
							});
						}
					});
			}
		);
	}

	saveSaleCode(itemIndex) {
		const { user } = this.props;

		this.setState(
			{
				codes: update(this.state.codes, {
					[itemIndex]: {
						$unset: ['errors'],
						saved: { $set: false },
						updateLoading: { $set: true },
					},
				}),
			},
			() => {
				let item = {
					...omit(this.state.codes[itemIndex], ['expires', 'sale_type']),
					expiry: this.state.codes[itemIndex].expires,
					price_type: this.state.codes[itemIndex].sale_type ? 'dollar' : 'percentage',
				};
				const { id } = item;

				const token = user.token;
				const AUTH_HEADER = {
					Authorization: REACT_APP_SITE_KEY + ':Bearer ' + token,
				};
				return axios
					.post(REACT_APP_API_URL + 'sale-code/' + id, item, {
						headers: AUTH_HEADER,
					})
					.then((response) => {
						// Check user token
						if (!!response.data.token) {
							this.props.userTokenUpdate('admin', response.data.token);
						} else {
							this.props.userLogout('admin');
						}

						if (
							response.status !== 200 ||
							(response.data.status && response.data.status !== 200)
						) {
							// Create error object
							let errorObj = '';
							if (!isEmpty(response.data.errors)) {
								errorObj = response.data.errors;
							} else if (!isEmpty(response.data.error)) {
								errorObj = { general: response.data.error };
							} else {
								errorObj = { general: response.data.message };
							}

							this.setState({
								codes: update(this.state.codes, {
									[itemIndex]: {
										updateLoading: { $set: false },
										errors: { $set: errorObj },
									},
								}),
							});
						} else {
							this.setState({
								codes: update(this.state.codes, {
									[itemIndex]: {
										saved: { $set: true },
										updateLoading: { $set: false },
									},
								}),
							});
						}
					})
					.catch((err) => {
						if (err.response) {
							this.setState({
								codes: update(this.state.codes, {
									[itemIndex]: {
										updateLoading: { $set: false },
										errors: {
											$set: {
												general: err.response.data.error
													? err.response.data.error
													: err.response.data.message,
											},
										},
									},
								}),
							});
						} else {
							this.setState({
								codes: update(this.state.codes, {
									[itemIndex]: {
										updateLoading: { $set: false },
										errors: { $set: { general: err.message } },
									},
								}),
							});
						}
					});
			}
		);
	}

	deleteSaleCode(itemIndex) {
		const { user } = this.props;

		this.setState(
			{
				codes: update(this.state.codes, {
					[itemIndex]: {
						$unset: ['errors'],
						saved: { $set: false },
						updateDeleting: { $set: true },
					},
				}),
			},
			() => {
				const { id } = this.state.codes[itemIndex];

				const token = user.token;
				const AUTH_HEADER = {
					Authorization: REACT_APP_SITE_KEY + ':Bearer ' + token,
				};
				return axios
					.delete(REACT_APP_API_URL + 'sale-code/' + id, {
						headers: AUTH_HEADER,
					})
					.then((response) => {
						// Check user token
						if (!!response.data.token) {
							this.props.userTokenUpdate('admin', response.data.token);
						} else {
							this.props.userLogout('admin');
						}

						if (
							response.status !== 200 ||
							(response.data.status && response.data.status !== 200)
						) {
							// Create error object
							let errorObj = '';
							if (!isEmpty(response.data.errors)) {
								errorObj = response.data.errors;
							} else if (!isEmpty(response.data.error)) {
								errorObj = { general: response.data.error };
							} else {
								errorObj = { general: response.data.message };
							}

							this.setState({
								codes: update(this.state.codes, {
									[itemIndex]: {
										updateDeleting: { $set: false },
										errors: { $set: errorObj },
									},
								}),
							});
						} else {
							this.setState({
								codes: update(this.state.codes, {
									$splice: [[itemIndex, 1]],
								}),
							});
						}
					})
					.catch((err) => {
						if (err.response) {
							this.setState({
								codes: update(this.state.codes, {
									[itemIndex]: {
										updateDeleting: { $set: false },
										errors: {
											$set: {
												general: err.response.data.error
													? err.response.data.error
													: err.response.data.message,
											},
										},
									},
								}),
							});
						} else {
							this.setState({
								codes: update(this.state.codes, {
									[itemIndex]: {
										updateDeleting: { $set: false },
										errors: { $set: { general: err.message } },
									},
								}),
							});
						}
					});
			}
		);
	}

	// ==================================================
	// DISCOUNT CODES
	// ==================================================
	addDiscountCode() {
		const { user } = this.props;

		this.setState(
			{
				bogoItem: update(this.state.bogoItem, {
					$unset: ['errors'],
					updateLoading: { $set: true },
				}),
				discountSuccess: '',
			},
			() => {
				let item = {
					is_editing: this.state.bogoEditId !== null ? true : false,
					...omit(this.state.bogoItem, [
						'discount_value',
						'auto_add',
						'give_free_shipping',
					]),
					discount_value:
						this.state.bogoItem.discount_type === 'free'
							? ''
							: this.state.bogoItem.discount_value,
					auto_add:
						this.state.bogoItem.auto_add === 1 &&
						!!this.state.bogoItem.get_products[0] &&
						this.state.bogoItem.get_products[0]['no_variants'] === 0
							? 0
							: this.state.bogoItem.auto_add,
					no_buy_items:
						!!this.state.bogoItem.no_buy_items &&
						(this.state.bogoItem.no_buy_items === true ||
							this.state.bogoItem.no_buy_items === 1)
							? 1
							: 0,
					give_free_shipping:
						!!this.state.bogoItem.give_free_shipping &&
						(this.state.bogoItem.give_free_shipping === true ||
							this.state.bogoItem.give_free_shipping === 1)
							? 1
							: 0,
				};
				const token = user.token;
				const AUTH_HEADER = {
					Authorization: REACT_APP_SITE_KEY + ':Bearer ' + token,
				};
				return axios
					.post(REACT_APP_API_URL + 'discount-multiple/', item, {
						headers: AUTH_HEADER,
					})
					.then((response) => {
						// Check user token
						if (!!response.data.token) {
							this.props.userTokenUpdate('admin', response.data.token);
						} else {
							this.props.userLogout('admin');
						}

						if (
							response.status !== 200 ||
							(response.data.status && response.data.status !== 200)
						) {
							// Create error object
							let errorObj = '';
							if (!isEmpty(response.data.errors)) {
								errorObj = response.data.errors;
							} else if (!isEmpty(response.data.error)) {
								errorObj = { general: response.data.error };
							} else {
								errorObj = { general: response.data.message };
							}

							this.setState({
								bogoItem: update(this.state.bogoItem, {
									updateLoading: { $set: false },
									errors: { $set: errorObj },
								}),
							});
						} else {
							this.setState({
								discountSuccess: response.data.message,
							});
							this.resetDiscountForm();
							this.loadDataDiscounts();
						}
					})
					.catch((err) => {
						if (err.response) {
							this.setState({
								bogoItem: update(this.state.bogoItem, {
									updateLoading: { $set: false },
									errors: {
										$set: {
											general: err.response.data.error
												? err.response.data.error
												: err.response.data.message,
										},
									},
								}),
							});
						} else {
							this.setState({
								bogoItem: update(this.state.bogoItem, {
									updateLoading: { $set: false },
									errors: { $set: { general: err.message } },
								}),
							});
						}
					});
			}
		);
	}

	editDiscountCode(itemIndex) {
		this.resetDiscountForm();
		this.setState({
			discountSuccess: '',
			bogoEditId: itemIndex,
			//Fill with correct buy/get category and products
			bogoItem: {
				...this.state.bogoItems[itemIndex],
				top_tier_id:
					this.state.bogoItems[itemIndex].top_tier_id === null
						? 0
						: this.state.bogoItems[itemIndex].top_tier_id,
				buy_categories:
					this.state.bogoItems[itemIndex].buy_item_type === 'category'
						? [
								{
									id: this.state.bogoItems[itemIndex].buy_item_id,
									title: this.state.bogoItems[itemIndex].buy_item_title,
									type: this.state.bogoItems[itemIndex].buy_item_type,
								},
						  ]
						: [],
				buy_products:
					this.state.bogoItems[itemIndex].buy_item_type === 'product' ||
					this.state.bogoItems[itemIndex].buy_item_type === 'variant'
						? [
								{
									id: this.state.bogoItems[itemIndex].buy_item_id,
									title: this.state.bogoItems[itemIndex].buy_item_title,
									type: this.state.bogoItems[itemIndex].buy_item_type,
								},
						  ]
						: [],
				get_categories:
					this.state.bogoItems[itemIndex].get_item_type === 'category'
						? [
								{
									id: this.state.bogoItems[itemIndex].get_item_id,
									title: this.state.bogoItems[itemIndex].get_item_title,
									type: this.state.bogoItems[itemIndex].get_item_type,
								},
						  ]
						: [],
				get_products:
					this.state.bogoItems[itemIndex].get_item_type === 'product' ||
					this.state.bogoItems[itemIndex].get_item_type === 'variant'
						? [
								{
									id: this.state.bogoItems[itemIndex].get_item_id,
									title: this.state.bogoItems[itemIndex].get_item_title,
									type: this.state.bogoItems[itemIndex].get_item_type,
									no_variants: this.state.bogoItems[itemIndex].no_variants,
								},
						  ]
						: [],
			},
		});
	}

	deleteDiscountCode(itemIndex) {
		const { user } = this.props;
		//Reset form if a deleted coupon is currently being edited
		if (itemIndex === this.state.bogoEditId) this.resetDiscountForm();

		this.setState(
			{
				bogoItems: update(this.state.bogoItems, {
					[itemIndex]: {
						$unset: ['errors'],
						saved: { $set: false },
						updateDeleting: { $set: true },
					},
				}),
			},
			() => {
				const { id } = this.state.bogoItems[itemIndex];

				const token = user.token;
				const AUTH_HEADER = {
					Authorization: REACT_APP_SITE_KEY + ':Bearer ' + token,
				};
				return axios
					.delete(REACT_APP_API_URL + 'discount-multiple/' + id, {
						headers: AUTH_HEADER,
					})
					.then((response) => {
						// Check user token
						if (!!response.data.token) {
							this.props.userTokenUpdate('admin', response.data.token);
						} else {
							this.props.userLogout('admin');
						}

						if (
							response.status !== 200 ||
							(response.data.status && response.data.status !== 200)
						) {
							// Create error object
							let errorObj = '';
							if (!isEmpty(response.data.errors)) {
								errorObj = response.data.errors;
							} else if (!isEmpty(response.data.error)) {
								errorObj = { general: response.data.error };
							} else {
								errorObj = { general: response.data.message };
							}

							this.setState({
								bogoItems: update(this.state.bogoItems, {
									[itemIndex]: {
										updateDeleting: { $set: false },
										errors: { $set: errorObj },
									},
								}),
							});
						} else {
							this.setState({
								bogoItems: update(this.state.bogoItems, {
									$splice: [[itemIndex, 1]],
								}),
							});
						}
					})
					.catch((err) => {
						if (err.response) {
							this.setState({
								bogoItems: update(this.state.bogoItems, {
									[itemIndex]: {
										updateDeleting: { $set: false },
										errors: {
											$set: {
												general: err.response.data.error
													? err.response.data.error
													: err.response.data.message,
											},
										},
									},
								}),
							});
						} else {
							this.setState({
								bogoItems: update(this.state.bogoItems, {
									[itemIndex]: {
										updateDeleting: { $set: false },
										errors: { $set: { general: err.message } },
									},
								}),
							});
						}
					});
			}
		);
	}

	resetDiscountForm() {
		this.setState({
			bogoItem: this.baseBogoState,
			bogoEditId: null,
		});
	}

	// ===================================================================================
	//  RENDER
	// ===================================================================================
	render() {
		const {
			codes,
			bogoItems,
			shipping,
			isLoading,
			updateSuccess,
			updateLoading,
			updateErrors,
		} = this.state;
		return (
			<div>
				<h1>Discounts</h1>

				<div className="fieldset">
					{/* FREE SHIPPING */}
					<div className="title-label">Free Shipping Option</div>
					<div className="instruction">
						Free shipping option allows you to discount your shipping charges, based on
						a minimum amount, to the shopping cart at the billing stage. If the user
						qualifies for free shipping on the conditions set, the amounts set in the
						merchant settings will default to $0. Customers can also apply a coupon
						code, if available, to this purchase along with free shipping.
					</div>

					{/* Loading */}
					{this.props.shippingIsLoading ? (
						<div className="pt2 pb2">
							<Loader />
						</div>
					) : (
						<div>
							{this.props.shippingError ? (
								<div className="error msg_animate">{this.props.shippingError}</div>
							) : (
								<div>
									<table className="product-prices product-prices--fixed-column">
										<tbody>
											<tr
												className="product-item"
												data-id="free_shipping_start"
											>
												<td className="item-title">Start</td>
												<td className="form-field">
													{updateErrors.free_shipping_start && (
														<div className="error msg_animate">
															{updateErrors.free_shipping_start}
														</div>
													)}
													<input
														type="text"
														className="readonly-clickable"
														placeholder="No start time set"
														maxLength="255"
														readOnly
														value={
															!!this.state.shipping.start &&
															this.state.shipping.start !== ''
																? this.state.shipping.start.format(
																		'YYYY-MM-DD HH:mm:ss'
																  )
																: ''
														}
														onClick={() =>
															this.setState({
																showStartDialog: !this.state
																	.showStartDialog,
															})
														}
													/>
													{this.state.showStartDialog && (
														<InputMoment
															className="top-margin"
															moment={
																!!this.state.shipping.start
																	? this.state.shipping.start
																	: moment()
															}
															onChange={(m) => {
																this.setState({
																	shipping: {
																		...this.state.shipping,
																		start: m,
																	},
																});
															}}
															prevMonthIcon="icon-circle-left"
															nextMonthIcon="icon-circle-right"
														/>
													)}
												</td>
												<td className="save-cell">
													<button
														className="btn"
														onClick={() =>
															this.setState({
																shipping: {
																	...this.state.shipping,
																	start: '',
																},
															})
														}
													>
														Clear
													</button>
												</td>
											</tr>
											<tr
												className="product-item"
												data-id="free_shipping_end"
											>
												<td className="item-title">End</td>
												<td className="form-field">
													{updateErrors.free_shipping_end && (
														<div className="error msg_animate">
															{updateErrors.free_shipping_end}
														</div>
													)}
													<input
														type="text"
														className="readonly-clickable"
														placeholder="No end time set"
														maxLength="255"
														readOnly
														value={
															this.state.shipping.end &&
															this.state.shipping.end !== ''
																? this.state.shipping.end.format(
																		'YYYY-MM-DD HH:mm:ss'
																  )
																: ''
														}
														onClick={() =>
															this.setState({
																showEndDialog: !this.state
																	.showEndDialog,
															})
														}
													/>
													{this.state.showEndDialog && (
														<InputMoment
															className="top-margin"
															moment={
																!!this.state.shipping.end
																	? this.state.shipping.end
																	: moment()
															}
															onChange={(m) => {
																this.setState({
																	shipping: {
																		...this.state.shipping,
																		end: m,
																	},
																});
															}}
															prevMonthIcon="icon-circle-left"
															nextMonthIcon="icon-circle-right"
														/>
													)}
												</td>
												<td className="save-cell">
													<button
														className="btn"
														onClick={() =>
															this.setState({
																shipping: {
																	...this.state.shipping,
																	end: '',
																},
															})
														}
													>
														Clear
													</button>
												</td>
											</tr>
											<tr
												className="product-item"
												data-id="free_shipping_end"
											>
												<td className="item-title free-shipping">
													<label className="tgl">
														<input
															type="checkbox"
															id="is_min_qty"
															value="1"
															checked={shipping.is_min_qty}
															disabled={updateLoading}
															onChange={(e) =>
																this.handleCheckboxClick(e)
															}
														/>
														<span
															data-on="MIN QNTY"
															data-off="MIN SALE"
														/>
													</label>
												</td>
												<td className="form-field" colSpan="2">
													{updateErrors.minimum_sale && (
														<div className="error msg_animate">
															{updateErrors.minimum_sale}
														</div>
													)}
													{updateErrors.minimum_items && (
														<div className="error msg_animate">
															{updateErrors.minimum_items}
														</div>
													)}
													{shipping.is_min_qty ? (
														<NumberFormat
															value={shipping.minimum_items}
															decimalScale={0}
															thousandSeparator={true}
															disabled={updateLoading}
															onKeyPress={(e) =>
																this.handleKeyPress(e)
															}
															onValueChange={(e) =>
																this.handleNumberChange(
																	'minimum_items',
																	e
																)
															}
														/>
													) : (
														<NumberFormat
															value={shipping.minimum_sale}
															placeholder="0.00"
															prefix={'$'}
															decimalScale={2}
															fixedDecimalScale={true}
															thousandSeparator={true}
															disabled={updateLoading}
															onKeyPress={(e) =>
																this.handleKeyPress(e)
															}
															onValueChange={(e) =>
																this.handleNumberChange(
																	'minimum_sale',
																	e
																)
															}
														/>
													)}
												</td>
											</tr>
											<tr>
												<td className="item-title">Coupon Codes</td>
												<td className="form-field" colSpan="2">
													{updateErrors.promo_codes_enabled && (
														<div className="error msg_animate">
															{updateErrors.promo_codes_enabled}
														</div>
													)}
													<label className="tgl">
														<input
															type="checkbox"
															id="promo_codes_enabled"
															value="1"
															checked={shipping.promo_codes_enabled}
															disabled={updateLoading}
															onChange={(e) =>
																this.handleCheckboxClick(e)
															}
														/>
														<span
															data-on="ENABLED"
															data-off="DISABLED"
														/>
													</label>
												</td>
											</tr>
											<tr>
												<td className="item-title">Active</td>
												<td className="form-field" colSpan="2">
													{updateErrors.active && (
														<div className="error msg_animate">
															{updateErrors.active}
														</div>
													)}
													<label className="tgl">
														<input
															type="checkbox"
															id="active"
															value="1"
															checked={shipping.active}
															disabled={updateLoading}
															onChange={(e) =>
																this.handleCheckboxClick(e)
															}
														/>
														<span data-on="ON" data-off="OFF" />
													</label>
												</td>
											</tr>
										</tbody>
									</table>

									<div className="btn_container">
										{updateErrors['submit-free-shipping'] && (
											<div className="error msg_animate">
												{updateErrors['submit-free-shipping']}
											</div>
										)}
										{updateSuccess && (
											<div className="success msg_animate">
												{updateSuccess}
											</div>
										)}
										<button
											className={
												'btn submit-btn' + (updateLoading ? ' loading' : '')
											}
											onClick={() => this.handleFreeShippingSubmit()}
											disabled={updateLoading}
										>
											<span>Submit</span>
										</button>
									</div>
								</div>
							)}
						</div>
					)}
					<hr />
					<div>
						<div className="fieldset">
							<div className="title-label">Coupon Codes</div>
							<div className="instruction">
								Coupon codes are created to provide the customer a dollar amount or
								percentage off their online purchase. Dates and minimum amount
								purchased parameters are set for each coupon code. Only 1 code can
								be applied at time of purchase. Coupon codes can be used along with
								Free Shipping if both available and meet the applied criteria.
							</div>
							<br />
							<div className="discount-selection">
								<h2>Select a Coupon Code Type</h2>
								<div className="discount-selection-btns">
									<button
										className={`discount-btn ${
											this.state.couponGeneralSelected ? 'selected' : ''
										}`}
										onClick={this.handleDiscountClick}
									>
										General Sale
									</button>
									<button
										className={`discount-btn ${
											!this.state.couponGeneralSelected ? 'selected' : ''
										}`}
										onClick={this.handleDiscountClick}
									>
										Buy X Get Y
									</button>
								</div>
							</div>

							{/* NEW CODE */}
							<div className="new-item">
								{this.state.couponGeneralSelected && (
									<table className="product-prices">
										<tbody>
											<SaleCodeItem
												item={this.state.newCode}
												index={'new'}
												handleChange={this.changeSaleCode.bind(this)}
												handleKeyPress={this.handleKeyPressSaleCode.bind(
													this
												)}
												handleCheckboxClick={this.handleCheckboxClickSaleCode.bind(
													this
												)}
												addItem={this.addSaleCade.bind(this)}
											/>
										</tbody>
									</table>
								)}
								{!this.state.couponGeneralSelected && (
									<div>
										<BuyXGetY
											item={this.state.bogoItem}
											index={'new'}
											success={this.state.discountSuccess}
											editId={this.state.bogoEditId}
											addItem={this.addDiscountCode.bind(this)}
											handleChange={this.changeDiscountCode.bind(this)}
											handleSelectBoxChange={this.handleUpdateSelectBox.bind(
												this
											)}
											handleCheckboxClick={this.handleCheckboxClickDiscountCode.bind(
												this
											)}
											handleCatProdChange={this.handleDiscountCatProdUpdate.bind(
												this
											)}
											handleCatProdDelete={this.handleDiscountCatProdDelete.bind(
												this
											)}
											resetDiscountForm={this.resetDiscountForm.bind(this)}
										/>
									</div>
								)}
							</div>
							{!this.state.couponGeneralSelected && (
								<table className="discount-items-list">
									<thead>
										<tr className="discount-item head">
											<td>#</td>
											<td>Coupon Code</td>
											<td>Start Date</td>
											<td>End Date</td>
											<td>Uses Left</td>
											<td>Action</td>
										</tr>
									</thead>
									<tbody>
										{bogoItems.map((item, i) => (
											<BuyXGetYItem
												key={i}
												item={item}
												index={i}
												editId={this.state.bogoEditId}
												editItem={this.editDiscountCode.bind(this)}
												deleteItem={this.deleteDiscountCode.bind(this)}
											/>
										))}
									</tbody>
								</table>
							)}

							{/* Has error */}
							{this.state.couponGeneralSelected &&
								(this.state.error ? (
									<div className="error">
										{Object.keys(this.state.error).map((key) => (
											<span key={key}>{this.state.error[key]}</span>
										))}
									</div> // EXISTING CODES
								) : // Loading codes
								isLoading ? (
									<div className="pt2 pb2">
										<Loader />
									</div> // Show codes
								) : codes.length ? (
									<table className="product-prices">
										<tbody>
											{codes.map((item, i) => (
												<SaleCodeItem
													key={i}
													item={item}
													index={i}
													handleChange={this.changeSaleCode.bind(this)}
													handleKeyPress={this.handleKeyPressSaleCode.bind(
														this
													)}
													handleCheckboxClick={this.handleCheckboxClickSaleCode.bind(
														this
													)}
													addItem={this.addSaleCade.bind(this)}
													saveItem={this.saveSaleCode.bind(this)}
													deleteItem={this.deleteSaleCode.bind(this)}
												/>
											))}
										</tbody>
									</table>
								) : (
									<div>There are no coupon codes at the moment.</div>
								))}
						</div>
					</div>
				</div>
			</div>
		);
	}
}

const mapStateToProps = (state) => {
	return {
		user: state.user.admin,
		shipping: !!state.siteInfo.shipping ? state.siteInfo.shipping : {},
		shippingIsLoading: !!state.siteInfo.shippingIsLoading
			? state.siteInfo.shippingIsLoading
			: false,
		shippingError: !!state.siteInfo.shippingError ? state.siteInfo.shippingError : '',
	};
};

export default connect(mapStateToProps, {
	addRoute,
	userTokenUpdate,
	userLogout,
	setpageTitle,
	getFreeShipping,
})(AdminDiscounts);



// WEBPACK FOOTER //
// ./src/components/admin/discounts/AdminDiscounts.js